module.exports = __webpack_public_path__ + "web/img/mvp-img5.0b64d27b.png";